import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import { Button } from '@mui/material';

export const StyledDrawer = styled(Drawer)({
  transition: 'transform 0.3s',
  '& .MuiDrawer-paper': {
    top: 65
  }
});

export const SupportButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'expanded'
})(({ expanded }) => ({
  minWidth: 'auto',
  position: 'fixed',
  bottom: 0,
  left: 0,
  zIndex: 1201,
  display: 'flex',
  justifyContent: 'start',
  padding: '12px 16px',
  width: 57,
  borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  '& svg': {
    color: 'rgba(0, 0, 0, 0.54)'
  },
  '& span': {
    paddingLeft: 32,
    display: expanded ? 'inline' : 'none',
    textTransform: 'none',
    fontSize: '1rem',
    lineHeight: '1.5',
    fontWeight: '400',
    letterSpacing: '0.00938em'
  },
  ...(expanded && {
    width: 250,
    transition: 'width 0.3s'
  }),
  '@media (max-height: 600px)': {
    display: 'none'
  }
}));
